import { payload } from "../../../../../../../node_modules/.pnpm/@sveltejs+kit@3.0.0_@opentelemetry+api@1.9.1_@sveltejs+vite-plugin-svelte@7.3.1_svelte@_629fecaee76a16a2d5d1e8782d171ab4/node_modules/@sveltejs/kit/src/runtime/client/payload.js";
const env = payload.env;

export const PUBLIC_NODE_ENV = "production";
export const PUBLIC_CLOUDINARY_CLOUD_NAME = "dvnbv3guw";
export const PUBLIC_BASE_URL = "https://app.fergmar.com";
export const PUBLIC_GOOGLE_PLACES_TOKEN = "AIzaSyC_W4KRaQeVe1rKBavNThmCDNbqW_AccYI";
export const PUBLIC_B2_CDN_BASE_URL = "https://cdn.fergmar.com";
export const PUBLIC_GOOGLE_MAPS_API_TOKEN = "AIzaSyC_W4KRaQeVe1rKBavNThmCDNbqW_AccYI";
export const PUBLIC_TURNSTILE_SITE_KEY = "0x4AAAAAAA-eXMNNze9ybfDO";
export const PUBLIC_SITE_URL = "https://app.fergmar.com";
